import SalaDeSituacaoIndexPage from "@/Pages/SalaDeSituacao/index.vue";

export default [
  {
    path: "/sala-de-situacao/",
    name: "salaDeSituacao",
    component: SalaDeSituacaoIndexPage,
  },
];
